import { useLingui } from "@lingui/react/macro";
import {
	createFileRoute,
	Link,
	Outlet,
	redirect,
} from "@tanstack/react-router";

export const Route = createFileRoute("/auth")({
	component: AuthLayout,
	beforeLoad: async ({ context }) => {
		if (context.session.user) {
			throw redirect({ to: "/" });
		}
	},
});

function AuthLayout() {
	const { t } = useLingui();
	return (
		<div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
			<div className="pointer-events-none absolute inset-0 mx-0 max-w-none overflow-hidden">
				<div className="absolute top-0 left-0 h-[25rem] w-full dark:[mask-image:linear-gradient(white,transparent)]">
					<div className="absolute inset-0 bg-linear-to-r from-[var(--brand-azure-radiance)] to-[var(--brand-orange-dark)] opacity-40 [mask-image:radial-gradient(farthest-side_at_top,white,transparent)] dark:from-[var(--brand-deep-cove)]/30 dark:to-[var(--brand-orange-dark)]/30 dark:opacity-100">
						<svg
							aria-hidden="true"
							className="absolute inset-x-0 inset-y-[-50%] h-[200%] w-full skew-y-[-18deg] fill-black/40 stroke-black/50 mix-blend-overlay dark:fill-white/2.5 dark:stroke-white/5"
						>
							<defs>
								<pattern
									id=":S1:"
									width="72"
									height="56"
									patternUnits="userSpaceOnUse"
									x="-12"
									y="4"
								>
									<path d="M.5 56V.5H72" fill="none" />
								</pattern>
							</defs>
							<rect
								width="100%"
								height="100%"
								strokeWidth="0"
								fill="url(#:S1:)"
							/>
							<svg x="-12" y="4" className="overflow-visible">
								<rect strokeWidth="0" width="73" height="57" x="288" y="168" />
								<rect strokeWidth="0" width="73" height="57" x="144" y="56" />
								<rect strokeWidth="0" width="73" height="57" x="504" y="168" />
								<rect strokeWidth="0" width="73" height="57" x="720" y="336" />
							</svg>
						</svg>
					</div>
					<svg
						viewBox="0 0 1113 440"
						aria-hidden="true"
						className="absolute top-0 left-1/2 ml-[-19rem] w-[69.5625rem] fill-muted blur-[26px] dark:hidden"
					>
						<path d="M.016 439.5s-9.5-300 434-300S882.516 20 882.516 20V0h230.004v439.5H.016Z" />
					</svg>
				</div>
			</div>
			<div className="relative flex w-full max-w-md flex-col gap-6">
				<Link
					className="flex items-center gap-2 self-center font-medium"
					to="/"
				>
					<img
						alt={t`Azerion's logo`}
						className="dark:hidden h-8"
						src="/azerion-logo-light.png"
					/>
					<img
						alt={t`Azerion's logo`}
						className="hidden dark:inline-block h-8"
						src="/azerion-logo-dark.png"
					/>
				</Link>
				<Outlet />
			</div>
		</div>
	);
}
